// PaymentConditionsComponent.js

import React from "react";
import images from "../../constant/images";
import { Nav } from "../../layouts/navbar/nav";
import { useTranslation } from "react-i18next";

const PaymentConditions = () => {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  return (
    <div
      className="flex flex-col gap-6 md:gap-12 min-h-screen"
      style={{
        backgroundImage: `url(${images.golf_field})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <Nav />
      <div className="flex justify-center px-4 md:mx-16">
        <div className="w-full sm:w-[80%] md:w-[70%] lg:w-[60%] mx-auto px-4 sm:px-8 md:px-16 mb-8 sm:mb-12 md:mb-20 shadow-[5px_3px_15px_rgba(0,0,0,0.3)] py-6 sm:py-8 md:py-12 border rounded-lg sm:rounded-xl md:rounded-3xl bg-white">
          <h1 className="text-xl sm:text-2xl font-bold mb-4">
            {t("payment.title")}
          </h1>

          <h2 className="text-base sm:text-lg font-semibold">
            {t("payment.paymentMode")}
          </h2>
          <p className="mb-4">{t("payment.paymentContent")}</p>
          <ul className="list-disc pl-5 mb-4">
            {t("payment.paymentDetails", { returnObjects: true })?.map(
              (item, index) => (
                <li key={index}>{item}</li>
              )
            )}
          </ul>

          <h2 className="text-base sm:text-lg font-semibold">
            {t("payment.paymentJustification")}
          </h2>
          <p className="mb-4">{t("payment.justificationContent")}</p>

          <h2 className="text-base sm:text-lg font-semibold">
            {t("payment.currency")}
          </h2>
          <p className="mb-4">{t("payment.currencyContent")}</p>

          <h2 className="text-base sm:text-lg font-semibold">
            {t("payment.refundPolicy")}
          </h2>
          <ul className="list-disc pl-5 mb-4">
            {t("payment.refundContent", { returnObjects: true })?.map(
              (item, index) => (
                <li key={index}>{item}</li>
              )
            )}
          </ul>

          <h2 className="text-base sm:text-lg font-semibold">
            {t("payment.assistance")}
          </h2>
          <p>{t("payment.assistanceContent")}</p>
          <p>{t("payment.email")}</p>
          <p>{t("payment.phone")}</p>
        </div>
      </div>
    </div>
  );
};

export default PaymentConditions;
